<div class="config-standard-header-container flex flex-row">
  <div class="header-left-side">
    <div *ngIf="required" class="required-dot">•  </div>
    <div class="header-text">{{headerText}} {{ required ? '(required)' : ''}}</div>
  </div>
  <div *ngIf="fieldCounter" class="count-text">{{currLen}}/{{maxLen}}</div>
</div>
